/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { type Signal, signal } from '@preact/signals-react'

import {
  type IUserFilters,
  type IUser,
  type IUserPagination,
  type IUsersState,
} from '@/interfaces'

const users: Signal<IUser[]> = signal([])
const permissions: Signal<string[] | number[]> = signal([])
const currentUser: Signal<IUser> = signal({})
const openDrawer: Signal<boolean> = signal(false)
const pagination: Signal<IUserPagination> = signal({
  data: [],
  page: 1,
  pageSize: 10,
  pageSizeOptions: [10, 20, 30, 50],
  total: 0,
})
const filters: Signal<IUserFilters> = signal({ text: null })
const openPermissionsDrawer: Signal<boolean> = signal(false)
const currentPermissionsRoleId: Signal<number | null> = signal(null)

export const UsersState: IUsersState = {
  currentPermissionsRoleId,
  currentUser,
  filters,
  openDrawer,
  openPermissionsDrawer,
  pagination,
  permissions,
  users,
}
